import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

// While the typed text is not a valid date, a datepicker control holds the text instead of a date struct.
const isDateStruct = (value: unknown): value is NgbDateStruct =>
    !!value && typeof value === "object"
    && ["year", "month", "day"].every(key => typeof (value as Record<string, unknown>)[key] === "number");

export const toIsoDate = (date: NgbDateStruct | null): string =>
    isDateStruct(date) ? `${date.year}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}` : "";

export const toDateStruct = (iso: string): NgbDateStruct | null => {
    const [year, month, day] = iso.split("-").map(Number);
    return year ? {year, month, day} : null;
};
